import { z } from "zod";

import { executionSourceSchema } from "../import";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";
import { auditEventImportingFailedSchema } from "./audit-event-importing-failed";

const auditEventImportingDataSchema = z.object({
	executionSource: executionSourceSchema,
});

const auditEventImportingInternalSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.Importing),
	data: auditEventImportingDataSchema,
});

export const auditEventImportingSchema = auditEventImportingInternalSchema
	.extend({ data: z.any() })
	.transform((event) => {
		if (event.data.failureReason) {
			return {
				...event,
				auditType: auditEventTypeSchema.enum.ImportingFailed,
			};
		}

		return event;
	})
	.pipe(z.union([auditEventImportingInternalSchema, auditEventImportingFailedSchema]));

export type AuditEventImporting = z.infer<typeof auditEventImportingInternalSchema>;
